export const options = [
    {
      name: "all",
      displayName: "Wszyscy",
    },
    {
      name: "seniors",
      displayName: "Seniorzy",
    },
    {
      name: "employees",
      displayName: "Opiekunowie",
    },
    {
      name: "employees_accepted",
      displayName: "Opiekunowie zweryfikowani",
    },
    {
      name: "employees_not_finished_payment",
      displayName: "Opiekunowie z niedokończoną płatnością weryfikacyjną",
    },
    {
      name: "selected_phone_numbers",
      displayName: "Wybrane numery telefonów",
    },
  ]

  export const tasksNavigationOptions = [
    {
      name:"Niedokończona/nierozpoczęta płatność",
      value:"UNFINISHED_VERIFICATION_PAYMENT"
    },
    {
      name:"Odrzucone przez admina",
      value:"REJECTED_BY_ADMIN"
    },

  ]